import { Pipe, PipeTransform, inject } from '@angular/core';
import { LangRouterService } from './lang-router.service';

@Pipe({ name: 'localize', standalone: true })
export class LocalizeRouterPipe implements PipeTransform {
  private langRouter = inject(LangRouterService);

  transform(path: string): string {
    return this.langRouter.translateRoute(path);
  }
}
